export const ORIGIN_SELECTOR_CONFIG: { [site: string]: string[] } = {
  DE: ['BER', 'DUS', 'HAM', 'FRA', 'MUC', 'STR', 'HAJ'],
  CH: ['ZRH', 'GVA'],
  AT: ['VIE', 'INN', 'SZG'],
  EE: ['TLL', 'TAY'],
  LV: ['RIX'],
  LT: ['VNO'],
  PL: ['WAW', 'GDN', 'KRK', 'WRO'],
  HU: ['BUD'],
  FR: ['PAR', 'NCE', 'BOD', 'LYS', 'MRS', 'TLS'],
  IT: ['MIL', 'ROM', 'VCE', 'VRN', 'BLQ', 'NAP'],
  ES: ['MAD', 'BCN', 'AGP', 'ALC', 'BIO', 'VLC', 'LCG', 'TCI', 'LPA'],
  PT: ['LIS', 'OPO', 'FAO', 'FNC'],
  US: ['NYC', 'LAX', 'CHI', 'DFW', 'SEA', 'MIA'],
  JP: ['TYO', 'OSA', 'FUK', 'NGO', 'CTS'],
  SE: ['STO', 'GOT'],
  NO: ['OSL', 'BGO', 'TRD', 'BOO', 'TOS', 'KKN'],
  GB: ['LON', 'EDI', 'MAN'],
  DK: ['CPH', 'BLL'],
};
